export function checkMatches(scene) {

    let matchGroups = [];

    // --- Horizontal ---
    for (
        let row = 0;
        row < scene.rows;
        row++
    ) {

        let currentMatch = [
            scene.grid[row][0]
        ];

        for (
            let col = 1;
            col < scene.cols;
            col++
        ) {

            const current =
                scene.grid[row][col];

            const previous =
                scene.grid[row][col - 1];

            if (
                current &&
                previous &&
                current.type.value ===
                previous.type.value
            ) {

                currentMatch.push(current);

            } else {

                if (
                    currentMatch.length >= 3
                ) {

                    matchGroups.push([
                        ...currentMatch
                    ]);
                }

                currentMatch = [current];
            }
        }

        if (
            currentMatch.length >= 3
        ) {

            matchGroups.push([
                ...currentMatch
            ]);
        }
    }


    // --- Vertical ---
    for (
        let col = 0;
        col < scene.cols;
        col++
    ) {

        let currentMatch = [
            scene.grid[0][col]
        ];

        for (
            let row = 1;
            row < scene.rows;
            row++
        ) {

            const current =
                scene.grid[row][col];

            const previous =
                scene.grid[row - 1][col];

            if (
                current &&
                previous &&
                current.type.value ===
                previous.type.value
            ) {

                currentMatch.push(current);

            } else {

                if (
                    currentMatch.length >=
                    scene.minimumLengthForPoints
                ) {

                    matchGroups.push([
                        ...currentMatch
                    ]);
                }

                currentMatch = [current];
            }
        }

        if (
            currentMatch.length >=
            scene.minimumLengthForPoints
        ) {

            matchGroups.push([
                ...currentMatch
            ]);
        }
    }


    if (matchGroups.length > 0) {

        scene.disableInput = true;

        handleMatches(
            scene,
            matchGroups
        );

        return true;

    } else {

        scene.disableInput = false;

        scene.checkGameEnd();
    }

    return false;
}


export function handleMatches(
    scene,
    matchGroups
) {

    let allMatchedItems = [];
    let totalPoints = 0;

    matchGroups.forEach(group => {

        const length = group.length;

        if (
            length >=
            scene.minimumLengthForPoints
        ) {

            let points = 0;

            /*
            if (length === 3) points = 50;
            else if (length === 4) points = 60;
            else if (length >= 5) points = 80;
            */

            var bonusPoints = 0;
            var groupSizeMultiplier = 0;

            if (matchGroups.length > 1) {

                bonusPoints =
                    scene.bonusPointsMultiGroups *
                    matchGroups.length;
            }

            if (
                length >
                scene.minimumLengthForPoints
            ) {

                groupSizeMultiplier =
                    scene.pointsMutiplier *
                    (
                        length -
                        scene.minimumLengthForPoints
                    );
            }

            console.log(
                1 +
                " | " +
                (bonusPoints / 100) +
                " | " +
                (groupSizeMultiplier / 100)
            );

            var totalMultiplier =
                1 +
                (bonusPoints / 100) +
                (groupSizeMultiplier / 100);

            console.log(totalMultiplier);

            points =
                scene.minimumPointsGain *
                totalMultiplier;

            points = Math.ceil(points);

            showFloatingPoints(
                scene,
                group,
                points
            );

            //totalPoints += points;
            totalPoints += points;

            allMatchedItems.push(...group);
        }
    });


    // Combo multiplier
    //const multiplier = matchGroups.length;

    //totalPoints *= multiplier;

    // removes decimals by making the numbers go to the value above
    // (so if 0.1 or 0.7 it = 1);
    totalPoints = Math.ceil(totalPoints);

    //scene.score += totalPoints;

    //console.log(
    //    "Scored:",
    //    totalPoints,
    //    "Total:",
    //    scene.score
    //);

    //scene.scoreText.setText(scene.score);

    // Remove duplicates (for cross shapes)
    const uniqueItems = [
        ...new Set(allMatchedItems)
    ];

    removeMatches(
        scene,
        uniqueItems,
        totalPoints
    );
}


export function showFloatingPoints(
    scene,
    group,
    points
) {

    // Get center of the group
    let avgX = 0;
    let avgY = 0;

    group.forEach(item => {

        avgX += item.x;
        avgY += item.y;
    });

    avgX /= group.length;
    avgY /= group.length;

    const text = scene.add.text(
        avgX,
        avgY,
        `+${points}`,
        {
            fontSize: '24px',
            fontStyle: 'bold',
            color: '#FFD700',
            stroke: '#000',
            strokeThickness: 4
        }
    );

    text.setOrigin(0.5);
    text.setDepth(10);

    // Small pop-in
    text.setScale(0);

    scene.tweens.add({
        targets: text,
        scale: 1.2,
        duration: 550,
        ease: 'Back.out'
    });

    // Float + fade
    scene.tweens.add({
        targets: text,
        y: avgY - 40,
        alpha: 0,
        duration: 2500,
        ease: 'Cubic.easeOut',

        onComplete: () => {
            text.destroy();
        }
    });
}


export function removeMatches(scene, matches, totalPoints) {

    let completed = 0;
    const total = matches.length;

    matches.forEach(item => {

        // Remove from grid immediately
        scene.grid[item.gridRow][item.gridCol] = null;

        breakDonut(
            scene,
            item,
            () => {

                const index = scene.items.indexOf(item);

                if (index !== -1) {
                    scene.items.splice(index, 1);
                }

                completed++;

                // Wait for ALL donuts to finish breaking
                if (completed === total) {

                    // ADD SCORE ONLY AFTER ANIMATION
                    scene.score += totalPoints;

                    scene.scoreText.setText(
                        scene.score
                    );

                    // Small juice
                    //scene.cameras.main.shake(100, 0.004);

                    scene.time.delayedCall(
                        150,
                        () => {
                            scene.collapseGrid();
                        }
                    );
                }
            }
        );
    });
}


export function breakDonut(scene, item,onComplete) {

    item.disableInteractive();

    scene.input.setDraggable(item, false);

    const baseScale = item.scale;

    // glow behind donut
    //const glow = scene.add.image(item.x, item.y, 'shine');

    //const glow = scene.add.sprite(item.x, item.y, 'sparkle');

    const sparkleTexture =
        Phaser.Utils.Array.GetRandom(
            scene.sparkleTextures
        );

    const glow = scene.add.sprite(item.x, item.y, sparkleTexture);

    glow.setDepth(item.depth - 1);

    glow.setBlendMode(Phaser.BlendModes.ADD);

    glow.setAlpha(0);

    //glow.setScale(0);
    glow.setScale(1.8);

    //glow.play('sparkleAnim');

    glow.play(`${sparkleTexture}Anim`);

    // shared timing factor
    // (slow everything down)
    const growTime = 330;
    const shrinkTime = 410;

    // -------------------------
    // 1. Grow phase (together)
    // -------------------------

    scene.tweens.add({
        targets: item,
        scale: baseScale * 1.15,
        duration: growTime,
        ease: 'Sine.easeOut'
    });


    scene.tweens.add({
        targets: glow,
        scale: 2.30,
        alpha: 0.9,
        duration: growTime,
        ease: 'Sine.easeOut'
    });

    /*
    scene.tweens.add({
        targets: glow,
        scale: 0.9,
        alpha: 0,
        duration: growTime,
        ease: 'Sine.easeOut'
    });
    */

    glow.once(
        'animationcomplete',
        () => {
            glow.destroy();
        }
    );


    // -------------------------
    // 2. Shrink phase
    // -------------------------

    scene.time.delayedCall(
        growTime * 0.9,
        () => {

            scene.tweens.add({
                targets: item,
                scale: 0,
                alpha: 0,
                duration: shrinkTime,
                ease: 'Cubic.easeIn'
            });

            // glow starts fading ONLY at
            // ~50% shrink point
            scene.time.delayedCall(
                shrinkTime * 0.4,
                () => {

                    scene.tweens.add({
                        targets: glow,
                        scale: 0,
                        alpha: 0,
                        duration: shrinkTime * 0.6,
                        ease: 'Cubic.easeIn'
                    });

                }
            );

        }
    );


    // -------------------------
    // cleanup
    // -------------------------

    scene.time.delayedCall(
        growTime + shrinkTime + 50,
        () => {

            item.destroy();
            glow.destroy();

            if (onComplete) {
                onComplete();
            }
        }
    );
}